var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAlertLeftArrowM(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "icon/outlined/directional/left",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "241mvd6uva"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "icon/outlined/directional/left (clip mask)",
    style: {
      fill: "none"
    },
    d: "M0 0h24v24H0z"
  }))), /*#__PURE__*/React.createElement("path", {
    "data-name": "icon/outlined/directional/left (clip mask)",
    style: {
      fill: "none"
    },
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "icon/outlined/directional/left",
    style: {
      clipPath: "url(#241mvd6uva)"
    }
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "icon/outlined/directional/left (clip group)"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "icon/outlined/directional/left (style)",
    style: {
      fill: "none"
    },
    d: "M0 0h24v24H0z"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.968 5.116V3.304a.187.187 0 0 0-.3-.148L6.1 11.409a.747.747 0 0 0 0 1.179l10.566 8.252a.187.187 0 0 0 .3-.148V18.88a.379.379 0 0 0-.143-.3l-8.435-6.581 8.437-6.588a.379.379 0 0 0 .143-.295z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlertLeftArrowM);
export default __webpack_public_path__ + "static/media/alert_left_arrow_m.fc719b88d3f3a4b5780902bde4269305.svg";
export { ForwardRef as ReactComponent };